import { render, staticRenderFns } from "./HeadUserInfo.vue?vue&type=template&id=0d15f5f2&scoped=true&"
import script from "./HeadUserInfo.vue?vue&type=script&lang=js&"
export * from "./HeadUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeadUserInfo.vue?vue&type=style&index=0&id=0d15f5f2&scoped=true&lang=less&"
import style1 from "./HeadUserInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15f5f2",
  null
  
)

export default component.exports